export default __webpack_public_path__ + "static/media/drums_direct.098c60a2.png";